<template>
  <v-form lazy-validation @submit.prevent="onLogin" id="loginForm" ref="form">
    <v-card-text class="forms">
      <v-text-field
        label="Usuário (e-mail)"
        name="login"
        type="text"
        v-model="payload.email"
        :rules="userRules"
        required
        background-color="white"
        solo
        hide-details="auto"
        class="mb-6"
      ></v-text-field>
      <v-text-field
        v-if="!showNewPassword"
        id="password"
        label="Senha"
        name="password"
        type="password"
        v-model="payload.senha"
        :rules="passwordRules"
        required
        background-color="white"
        solo
        append-icon="mdi-eye-off"
        @click:append="showNewPassword = true"
        hide-details="auto"
      ></v-text-field>
      <v-text-field
        v-if="showNewPassword"
        id="password"
        label="Senha"
        name="password"
        type="text"
        v-model="payload.senha"
        :rules="passwordRules"
        required
        background-color="white"
        solo
        append-icon="mdi-eye"
        @click:append="showNewPassword = false"
        hide-details="auto"
      ></v-text-field>
    </v-card-text>
    <hr />
    <v-card-actions>
      <v-row>
        <v-col class="pt-0">
          <div class="text-right text">
            <v-btn
              text
              color="accent"
              :href="'#/auth/lost-password'"
              :style="{
                color: '#65b4f8',
              }"
              class="textos"
            >
              NÃO SABE SUA SENHA? <span class="cliqueAqui">CLIQUE AQUI</span>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-actions>
    <v-card-actions>
      <v-row>
        <v-col>
          <div class="text-center mb-3">
            <v-btn
              color="primary"
              :style="{
                backgroundColor:
                  isGov || isTur
                    ? '#5a5454 !important'
                    : isSala
                    ? '#65b4f8 !important'
                    : '#5a5454',
              }"
              type="submit"
              id="btnEntrar"
            >
              Entrar
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Auth from "@/Auth.js";
import { configuracoesAPI } from "@/modules/configuracao";
import { groupsPermissionAPI } from "@/modules/groups";

export default {
  computed: {
    ...mapGetters([
      "token",
      "forcedLogout",
      "isAT",
      "isSala",
      "isGov",
      "isTur",
    ]),
  },
  data() {
    return {
      payload: {},
      passwordRules: [(v) => !!v || "O campo senha é obrigatório"],
      userRules: [(v) => !!v || "O campo usuário é obrigatório"],
      valid: true,
      expired: Auth.getItem("expired"),
      lastRoute: Auth.getItem("last_route") || null,
      showNewPassword: false,
    };
  },
  methods: {
    ...mapActions([
      "setToken",
      "setConfig",
      "setUser",
      "setIsLogged",
      "setLoading",
      "setUf",
      "setAnalista",
      "setAD",
      "setForcedLogout",
      "setFullAdmin",
      "setGroupsConfig",
    ]),
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    async onLogin() {
      var isValid = await this.check();
      if (!isValid) return;
      this.setLoading(true);
      this.$http
        .post("api/login", this.payload)
        .then(async ({ data }) => {
          if (data.user) {
            delete data.user.senha;
            const mappedUser = {
              ...data.user,
              permissoes: data.user.permissoes.map((item) => ({
                ...item,
                municipio: {},
              })),
            };

            this.setUser(mappedUser);

            this.setForcedLogout(false);
            if (data.user.email === "admin@admin.com.br")
              this.setFullAdmin(true);

            this.setToken(data.accessToken);

            this.$http.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${this.token}`;

            const config = await configuracoesAPI.get();
            const groupPermission = await groupsPermissionAPI.getByGroup(
              data.user.grupo.usuarioGrupoId
            );

            var uf = config.data.filter((item) => item.nome === "sigla")[0]
              .valor;

            const configData = config.data.filter(
              (item) => item.configuracaoId == 1
            )[0];

            delete configData.relatorioFinal;
            this.setConfig(configData);
            this.setGroupsConfig(groupPermission.data);

            this.$notification.success("Logado com sucesso!", { timer: 3 });
            this.$forceUpdate();
            if (
              this.expired === true &&
              this.forcedLogout === false &&
              this.lastRoute !== "/auth/login"
            ) {
              Auth.setItem("expired", false);
              this.$router.push(this.lastRoute);
            } else {
              this.$router.push("/cidade");
            }
          } else {
            console.log("Ocorreu um erro: usuario retornado foi : ", data);

            this.$notification.error(
              "Aconteceu um problema, contate o administrador do sistema",
              { timer: 10 }
            );
          }
          this.setLoading(false);
        })
        .catch((err) => {
          console.log("Erro ao fazer login: ", err);
          this.setLoading(false);

          if (err.response && err.response.data.usuarioBloqueado) {
            this.$notification.error(err.response.data.message, {
              timer: 10,
            });
          } else if (err.response && err.response.data.credencialErrada) {
            this.$notification.error(
              "Por gentileza, verifique as credenciais digitadas",
              { timer: 5 }
            );
          } else {
            this.$notification.error(
              "Ocorreu um erro, entre em contato com o administrador do sistema.",
              { timer: 10 }
            );
          }
          this.setForcedLogout(true);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  a {
    white-space: normal;
  }
}

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #f0f0f0;
  margin: 1em 2em;
}

.forms {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
}

@media screen and (max-width: 760px) {
  .text-right {
    .textos {
      font-size: 12px;
    }
  }
}
</style>
